const convertToTimeZone = offSet => {
  const currentDate = new Date()
  //getTimezoneOffset returns offset in minutes, so multiplying with 60000 to convert to ms
  const utcDate =
    currentDate.getTime() + currentDate.getTimezoneOffset() * 60000
  // offSet is sent in hours, multiplying with 3600000 to convert it to ms
  return new Date(utcDate + 3600000 * offSet)
}

export default convertToTimeZone
